import login from "@/views/login/login";
import layout from "../layout";
const constantRouterMap = [
  {
    path: "/login",
    name: "login",
    component: login
  },
  {
    path: "/",
    redirect: "/VIpManage",
    meta: {}
  },
  // 首页
  {
    path: "/dashboard",
    component: layout,
    children: [
      {
        path: "/dashboard",
        name: "首页",
        component: () => import("@/views/home/home"),
        meta: {}
      }
    ]
  },
  {
    path: "/VIpManage",
    component: layout,
    name: "会员管理",
    redirect: "/VIpManage/viplist",
    meta: {
      breadcrumbs: ["会员管理"]
    },
    children: [
      {
        path: "/VIpManage/viplist",
        name: "会员列表",
        component: () => import("../views/system/VIpManage/viplist"),
        meta: {
          parentName: "会员管理",
          breadcrumbs: ["会员管理", "会员列表"]
        }
      },
      {
        path: "/VIpManage/vipapplyfor",
        name: "会员申请审批",
        component: () => import("../views/system/VIpManage/vipapplyfor"),
        meta: {
          parentName: "会员管理",
          breadcrumbs: ["会员管理", "会员申请审批"]
        }
      }
    ]
  },
  {
    path: "/FileMange",
    component: layout,
    name: "文库管理",
    redirect: "/FileMange/ColumnManage",
    meta: {
      breadcrumbs: ["文库管理"]
    },
    children: [
      {
        path: "/FileMange/ColumnManage",
        name: "栏目管理",
        component: () => import("../views/system/FileMange/ColumnManage"),
        meta: {
          breadcrumbs: ["文库管理", "栏目管理"]
        }
      },
      {
        path: "/FileMange/PeriodicalManage",
        name: "期刊管理",
        component: () => import("../views/system/FileMange/PeriodicalManage"),
        meta: {
          breadcrumbs: ["文库管理", "期刊管理"]
        }
      },
      {
        path: "/FileMange/Periodicalcheck/:Id/:year/:month",
        name: "期刊管理-查看",
        component: () => import("../views/system/FileMange/Periodicalcheck"),
        meta: {
          breadcrumbs: ["文库管理", "期刊管理", "期刊管理-查看"]
        }
      },
      {
        path: "/FileMange/ArticleManage",
        name: "文章管理",
        component: () => import("../views/system/FileMange/ArticleManage"),
        meta: {
          breadcrumbs: ["文库管理", "文章管理"]
        }
      }
    ]
  },
   {
    path: "/SystemMange",
    component: layout,
    name: "系统管理",
    redirect: "/SystemMange/UserManage",
    meta: {
      breadcrumbs: ["系统管理"]
    },
    children: [
      {
        path: "/SystemMange/UserManage",
        name: "用户管理",
        component: () => import("../views/system/SystemMange/UserManage"),
        meta: {
          breadcrumbs: ["系统管理", "用户管理"]
        }
      },
      {
        path: "/SystemMange/RoleManage",
        name: "角色管理",
        component: () => import("../views/system/SystemMange/RoleManage"),
        meta: {
          breadcrumbs: ["系统管理", "角色管理"]
        }
      },
      {
        path: "/SystemMange/MenuManage",
        name: "权限管理",
        component: () => import("../views/system/SystemMange/MenuManage"),
        meta: {
          breadcrumbs: ["系统管理", "权限管理"]
        }
      },
      {
        path: "/SystemMange/DictionariesManage",
        name: "字典管理",
        component: () => import("../views/system/SystemMange/DictionariesManage"),
        meta: {
          breadcrumbs: ["系统管理", "字典管理"]
        }
      },
      {
        path: "/SystemMange/LoginManage",
        name: "登录日志",
        component: () => import("../views/system/SystemMange/LoginManage"),
        meta: {
          breadcrumbs: ["系统管理", "登录日志"]
        }
      }
    ]
  },
  // 404
  {
    path: "*",
    component: () => import("@/views/404")
  }
];
export default constantRouterMap;
